var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDefaultHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#72B875"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C11 19.7239 11.2239 19.5 11.5 19.5H23V20.5H11.5C11.2239 20.5 11 20.2761 11 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 17C23.4477 17 23 17.4477 23 18V22C23 22.5523 23.4477 23 24 23H28C28.5523 23 29 22.5523 29 22V18C29 17.4477 28.5523 17 28 17H24ZM25.5 18.5C25.5 18.2239 25.7239 18 26 18C26.2761 18 26.5 18.2239 26.5 18.5V19.5H27.5C27.7761 19.5 28 19.7239 28 20C28 20.2761 27.7761 20.5 27.5 20.5H26.5V21.5C26.5 21.7761 26.2761 22 26 22C25.7239 22 25.5 21.7761 25.5 21.5V20.5H24.5C24.2239 20.5 24 20.2761 24 20C24 19.7239 24.2239 19.5 24.5 19.5H25.5V18.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E6EAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDefaultHover);
export default __webpack_public_path__ + "static/media/AddDefaultHover.eec8e033b3b18e68379296aab67beda3.svg";
export { ForwardRef as ReactComponent };